import axios from "axios";

import { auth } from "@Firebase/firebase";
import { CreateUserRequest, User } from "@Types/users";
import { HttpQuery, PaginatedResult } from "@Types/http";

import { queryClient } from "../App";

export const getUsers = (
  query?: HttpQuery
): (() => Promise<PaginatedResult<User[]>>) => {
  return async () => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.get(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/lender_user/`,
      {
        headers: {
          authorization: `Bearer ${token}`,
          query:
            query && Object.keys(query)?.length
              ? JSON.stringify(query)
              : undefined,
        },
      }
    );

    return {
      docs: response.data.result?.docs ?? [],
      totalDocs: response.data.result?.totalDocs ?? 0,
      totalPages: response.data.result?.totalPages ?? 0,
    };
  };
};

export const getUser = (id: string): (() => Promise<User>) => {
  return async () => {
    const token = await auth.currentUser?.getIdToken();
    const response = await axios.get(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/lender_user/${id}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.result;
  };
};
export const getCurrentUser = (): (() => Promise<User>) => {
  return async () => {
    const token = await auth.currentUser?.getIdToken();
    const response = await axios.get(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/current_user/`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.result;
  };
};
export const updateUser = (): ((user: User) => Promise<User>) => {
  return async (user) => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.put(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/lender_user/${user._id}`,
      user,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );

    queryClient.setQueryData<User>(
      [`member-${user._id}`],
      () => response.data.result
    );
    return response.data.result;
  };
};
export const deleteUser = (): ((user: User) => Promise<User>) => {
  return async (user) => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.delete(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/lender_user/${user._id}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data.result;
  };
};

export const disableUser =
  (): ((user: User) => Promise<User>) => async (user) => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.put(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/disable_user/${user._id}`,
      {},
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data.result;
  };

export const createUser = (): ((user: CreateUserRequest) => Promise<User>) => {
  return async (user) => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.post(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/lender_user/`,
      user,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data.result;
  };
};
export const resendRegistrationLink = (): ((id: string) => Promise<User>) => {
  return async (id) => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.put(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/send-registration-link/${id}`,
      {},
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data.result;
  };
};

export const acceptTermsAndConditions = (): (() => Promise<User>) => {
  return async () => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.put(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/accept-terms-and-conditions`,
      {},
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data.result;
  };
};
